export default "__VITE_ASSET__C9x4Q2Yv__"